import _ from 'lodash';

export const isValidEan = ean => /^[0-9]{13}$/.test(_.toString(ean));
